import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AlertService, KeycloakService } from '@muvstok/ngx-muvstok';
import { Router } from '@angular/router';

export class BaseService {
  protected baseUrlMuvStok: string;

  protected http: HttpClient;
  protected alert: AlertService;
  protected router: Router;
  protected readonly keycloakService: KeycloakService;

  constructor() {
    this.baseUrlMuvStok = environment.baseUrlMuvStok;

    this.router = inject(Router);
    this.http = inject(HttpClient);
    this.keycloakService = inject(KeycloakService);
    this.alert = inject(AlertService);
  }

  get accountId(): number {
    return this.keycloakService.getUserId() ?? 0;
  }

    getHeaders() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: {},
    };
  }

  get accountName(): string {
    return this.keycloakService.getUsername() ?? '';
  }

  get email(): string {
    return this.keycloakService.getEmail() ?? '';
  }

  get actions(): number[] {
    return this.keycloakService.getActions() ?? [];
  }

  get token(): string {
    return this.keycloakService.getToken() ?? '';
  }

  LogOut() {
    this.keycloakService.logout();
  }
}
